import { useMutation } from '@apollo/client';
import { SAVE_PREFERENCES } from '@/common/graphql/mutations/preferences';
import { useModalControl } from '@/common/hooks/useModalControl';
import { captureException } from '@/shared/utils/sentry';
import { useConvertShiftPreferences } from './use-convert-shift-preferences';

export const useSaveShiftPreferences = ({
  externalSubmit = null,
  handleError = () => {},
}) => {
  const [savePreferences] = useMutation(SAVE_PREFERENCES);
  const { convertToSubmit } = useConvertShiftPreferences();
  const { actions } = useModalControl();

  const submitPreferences = async (values, setters) => {
    try {
      const { data } = await savePreferences({
        variables: {
          preferences: { preferences: JSON.stringify(values) },
        },
      });

      if (!data?.saveVetPreferences?.success) throw new Error();

      actions.setSubmitted(true);
      actions.close();
    } catch (exception) {
      captureException({
        during: 'mutation',
        module: 'shift-preferences',
        payload: values,
        exception,
      });
      setters.setSubmitting(false);
      handleError('Could not save your preferences');
    }
  };

  const onSubmit = (values, setters) => {
    const preferences = convertToSubmit(values);

    if (externalSubmit) {
      externalSubmit(preferences, setters);
    } else {
      submitPreferences(preferences, setters);
    }
  };

  return { onSubmit };
};
